import type React from 'react'
import { memo } from 'react'

export type TooltipProps = {
  children: React.ReactNode
  text: React.ReactNode
  link?: string
  isDebug?: boolean
}

const Tooltip: React.FC<TooltipProps> = memo(
  ({ text, link, children, isDebug }) => (
    <span className="group relative inline-flex items-center z-50">
      <span
        className={`text-xs pointer-events-none absolute bottom-6 left-1/2 -translate-x-1/2 rounded bg-gray-900 px-2 py-1 text-white-100 opacity-0 transition before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:border-4 before:border-transparent before:border-t-gray-900 before:content-[''] group-hover:opacity-100 ${
          isDebug
            ? 'whitespace-break-spaces break-words max-w-md'
            : (text || <></>).toString().length > 20
              ? 'w-40'
              : 'whitespace-nowrap'
        }`}
      >
        {text}
        {link && (
          <a href={link} target="_blank" rel="noreferrer" className="mt-4">
            More Info
          </a>
        )}
      </span>

      {children}
    </span>
  ),
)

Tooltip.displayName = 'Tooltip'

export default Tooltip
